// extracted by mini-css-extract-plugin
module.exports = {"backArrowButton":"_3mYNNrlhMfsIM6c-EoBQ2y"};